<template>
  <textarea
    ref="textarea"
    :placeholder="placeholder"
    v-model="text"
    @keydown="setHeight()"
  >
  </textarea>
</template>

<script>
//= jquery
import $ from 'jquery'

export default {
  name: 'text-area',

  props: {
    reset: '',
    placeholder: { String },
    content: [String],
    mode: {
      type: [String],
      default: 'add'
    }
  },

  computed: {
    text: {
      get () {
        return this.content || ''
      },
      set (newVal) {
        return this.$emit('input', newVal)
      }
    }
  },

  data () {
    return {
    }
  },

  watch: {
    text () {
      let self = this
      self.$emit('input', this.text)
    },

    reset () {
      if (!isNaN(this.reset)) {
        this.text = ''
      }
    }
  },

  mounted () {
    this.setHeight()

    if (this.mode === 'edit') {
      this.text = this.content
    }
  },

  beforeUpdate () {
    if (this.mode === 'edit') {
      this.text = this.content
    }
  },

  methods: {
    setHeight () {
      setTimeout(() => {
        $(this.$refs.textarea).css({ 'height': 'auto' })
        $(this.$refs.textarea).css({ 'height': this.$refs.textarea.scrollHeight })
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
  textarea {
    background-color: transparent;
    border: 0;
    font-family: inherit;
    min-height: 30px;
    overflow: hidden !important;
    resize: none;
  }
</style>
